import type { State } from '../../types';
import type { ContactPersonViewModel } from '@trinnvis/dabih-api-client';
import { _sortByFirstAndLastName } from '../utilities/_sortByFirstAndLastName';
import { toList } from '../toList';

export function contactsDeleted(state: State): ContactPersonViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.contactsById)
    .filter(function (e) {
      return e.deleted;
    })
    .sort(_sortByFirstAndLastName);
}
